import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {BaseOverview} from '../BaseFinancialInstruments';
import {useDispatch, useSelector} from 'react-redux';
import {useState} from 'react';
import {useMutation, useQuery} from '@apollo/client';
import {Spin} from 'antd';
import {ConfirmModal} from 'pages/adminOpportunities/stocksListings/ViewOrders/HandleOrders';
import {
  currentInstrumentKey,
  financialInstrumentConfig,
} from '../modules/financialInstrumentConfig';

const BondOverview = () => {
  const location = useLocation();
  const {
    mutation,
    handleUpdate,
    route,
    handleDispatch,
    title,
    overviewSelector,
    QUERY,
  } = financialInstrumentConfig[currentInstrumentKey(location.pathname)];

  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [updatedValues, setUpdatedValues] = useState({});
  const {assetId, lang, id} = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const overviewData = useSelector(overviewSelector);

  const [updateBond, {loading: loadingUpdate}] = useMutation(mutation);
  const {
    data: updateData,
    refetch,
    loading,
  } = useQuery(QUERY, {
    variables: {
      getFinancialInstrumentId: id,
      language: lang,
    },
    skip: !id,
  });

  const handleSubmit = values => {
    if (id) {
      setOpenUpdateModal(true);
      // `whatWeOffer` was removed by the instrument migration — sending it
      // rejects the whole update.
      setUpdatedValues({...values});
    } else {
      dispatch(handleDispatch({...values}));
      navigate(route({param: assetId, name: 'documents'}));
    }
  };

  if (loading) {
    return (
      <div className="query-loading">
        <Spin size="large" />
        <h1>Loading...</h1>
      </div>
    );
  }

  return (
    <div>
      <BaseOverview
        onSubmit={handleSubmit}
        existingData={
          id ? updateData?.getFinancialInstrument?.data || {} : overviewData
        }
      />
      <ConfirmModal
        openModal={openUpdateModal}
        setOpenModal={() => setOpenUpdateModal(false)}
        loading={loadingUpdate}
        title={`Update ${title}`}
        confirmText={`Are you sure you want update to this ${title}?`}
        handleOperation={() =>
          handleUpdate(
            updateBond,
            id,
            lang,
            updatedValues,
            refetch,
            setOpenUpdateModal,
          )
        }
      />
    </div>
  );
};

export default BondOverview;
